import IframeActivity from "./IframeActivity";

export default function FallacyDetective() {
    return (
        <IframeActivity
            src="/activities/fallacy-detective/index.html"
            title="Fallacy Detective"
        />
    );
}